import React from "react";
import logoDark from "@/assets/img/logo-dark.svg";
import logoLight from "@/assets/img/logo.svg";
import googlePlay from "@/assets/img/icons/googleplay.svg";
import appStore from "@/assets/img/icons/appstore.svg";
import footerImg from "@/assets/img/bg/footer.svg";
import card01 from "@/assets/img/icons/card-01.svg";
import card02 from "@/assets/img/icons/card-02.svg";
import card03 from "@/assets/img/icons/card-03.svg";
import card04 from "@/assets/img/icons/card-04.svg";
import card05 from "@/assets/img/icons/card-05.svg";
import card06 from "@/assets/img/icons/card-06.svg";

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-top">
          <div className="row row-cols-lg-5 row-cols-md-3 row-cols-sm-2 row-cols-1">
            {/* Cột 1 */}
            <div className="col">
              <div className="footer-widget">
                <h5>Trang</h5>
                <ul className="footer-menu">
                  <li>
                    <a href="team.html">Đội ngũ</a>
                  </li>
                  <li>
                    <a href="pricing-plan.html">Gói giá</a>
                  </li>
                  <li>
                    <a href="gallery.html">Thư viện</a>
                  </li>
                  <li>
                    <a href="profile-settings.html">Cài đặt</a>
                  </li>
                  <li>
                    <a href="my-profile.html">Trang cá nhân</a>
                  </li>
                  <li>
                    <a href="agent-listings.html">Danh sách đại lý</a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Cột 2 */}
            <div className="col">
              <div className="footer-widget">
                <h5>Công ty</h5>
                <ul className="footer-menu">
                  <li>
                    <a href="about-us.html">Về chúng tôi</a>
                  </li>
                  <li>
                    <a href="#">Tuyển dụng</a>
                  </li>
                  <li>
                    <a href="blog-grid.html">Blog</a>
                  </li>
                  <li>
                    <a href="#">Chương trình đối tác</a>
                  </li>
                  <li>
                    <a href="add-flight.html">Đăng tour của bạn</a>
                  </li>
                  <li>
                    <a href="#">Đối tác của chúng tôi</a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Cột 3 */}
            <div className="col">
              <div className="footer-widget">
                <h5>Điểm đến</h5>
                <ul className="footer-menu">
                  <li>
                    <a href="#">Hawaii</a>
                  </li>
                  <li>
                    <a href="#">Istanbul</a>
                  </li>
                  <li>
                    <a href="#">San Diego</a>
                  </li>
                  <li>
                    <a href="#">Bỉ</a>
                  </li>
                  <li>
                    <a href="#">Los Angeles</a>
                  </li>
                  <li>
                    <a href="#">New York</a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Cột 4 */}
            <div className="col">
              <div className="footer-widget">
                <h5>Hỗ trợ</h5>
                <ul className="footer-menu">
                  <li>
                    <a href="contact-us.html">Liên hệ</a>
                  </li>
                  <li>
                    <a href="#">Thông báo pháp lý</a>
                  </li>
                  <li>
                    <a href="privacy-policy.html">Chính sách bảo mật</a>
                  </li>
                  <li>
                    <a href="terms-conditions.html">Điều khoản & Điều kiện</a>
                  </li>
                  <li>
                    <a href="chat.html">Hỗ trợ trò chuyện</a>
                  </li>
                  <li>
                    <a href="#">Chính sách hoàn tiền</a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Cột 5 */}
            <div className="col">
              <div className="footer-widget">
                <h5>Dịch vụ</h5>
                <ul className="footer-menu">
                  <li>
                    <a href="hotel-grid.html">Khách sạn</a>
                  </li>
                  <li>
                    <a href="#">Tìm hoạt động</a>
                  </li>
                  <li>
                    <a href="flight-grid.html">Tìm chuyến bay</a>
                  </li>
                  <li>
                    <a href="tour-grid.html">Cho thuê kỳ nghỉ</a>
                  </li>
                  <li>
                    <a href="car-grid.html">Thuê xe</a>
                  </li>
                  <li>
                    <a href="tour-details.html">Gói du lịch</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="footer-wrap bg-white">
            <div className="row align-items-center">
              <div className="col-lg-6 col-xl-3 col-xxl-3">
                <div className="mb-3 text-center text-xl-start">
                  <a href="#" className="d-block footer-logo-light">
                    <img src={logoDark} alt="logo" />
                  </a>
                  <a href="#" className="footer-logo-dark">
                    <img src={logoLight} alt="logo" />
                  </a>
                </div>
              </div>
              <div className="col-lg-6 col-xl-4 col-xxl-4">
                <div className="d-flex align-items-center justify-content-center flex-wrap">
                  <h6 className="fs-14 fw-medium me-2 mb-2">
                    Tải ứng dụng tại:{" "}
                  </h6>
                  <a href="#" className="d-block mb-3 me-2">
                    <img src={googlePlay} alt="Google Play" />
                  </a>
                  <a href="#" className="d-block mb-3">
                    <img src={appStore} alt="App Store" />
                  </a>
                </div>
              </div>
              <div className="col-lg-12 col-xl-5 col-xxl-5">
                <div className="d-sm-flex align-items-center justify-content-center justify-content-xl-end">
                  <div className="d-flex align-items-center justify-content-center justify-content-sm-start me-0 pe-0 me-sm-3 pe-sm-3 border-end mb-3">
                    <span className="avatar avatar-lg bg-primary rounded-circle flex-shrink-0">
                      <i className="ti ti-headphones-filled fs-24"></i>
                    </span>
                    <div className="ms-2">
                      <p className="mb-1">Hỗ trợ khách hàng</p>
                      <p className="fw-medium text-dark">+1 56589 54598</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-center justify-content-sm-start mb-3">
                    <span className="avatar avatar-lg bg-secondary rounded-circle flex-shrink-0">
                      <i className="ti ti-message fs-24 text-gray-9"></i>
                    </span>
                    <div className="ms-2">
                      <p className="mb-1">Gửi email cho chúng tôi</p>
                      <p className="fw-medium text-dark">
                        <a href="#">[email&#160;protected]</a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-img">
            <img
              src={footerImg}
              className="img-fluid"
              alt="footer background"
            />
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <p className="fs-14">
                  Bản quyền &copy; 2025. Đã đăng ký bản quyền bởi{" "}
                  <a href="#" className="text-primary fw-medium">
                    DreamsTour
                  </a>
                </p>
                <div className="d-flex align-items-center">
                  <ul className="social-icon">
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-x-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-linkedin"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-brands fa-pinterest"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <ul className="card-links">
                  <li>
                    <a href="#">
                      <img src={card01} alt="Visa" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={card02} alt="MasterCard" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={card03} alt="PayPal" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={card04} alt="JCB" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={card05} alt="Amex" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={card06} alt="Discover" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
